
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import datePick from '../common/datePick.vue'
import personPick from '../common/personPick.vue'
import choosePerson from '../common/choosePerson.vue'
import Agreement from '../common/Agreement.vue'

var DEBOUNCE_TIME = 400;

export default {
components: {
Group,
Cell,
XInput,
Badge,
XButton,
Icon,
PopupPicker,
datePick,
personPick,
choosePerson,
Agreement
},
data() {
return {
promise: '',
promiseCallPrice: "222",
upvalue: '',  //上车位置
initStation: "", //绑定上车位置的值
downvalue: '', //下车位置
jsDate: "",     //实际时间
jspickerDate: [], //pick时间
showPickerPerson: false, //pick显示
personList: [[1, 2, 3, 4, 5]], //pick数据
jspickerPerson: [],
jsPerson: sessionStorage.getItem('jbpersonNum') || '1',      //人数
jsPassanger: '', //乘车人
defaultFlag: true,
checkBoxFlag: true,     //判断checkbox是否选中
checkBoxValue: 'success', //改变checkbox的颜色
showPopupPicker: false, //显示弹出的日历
list3: [],
loginFlag: false,
payPrice: "", //实际支付的金额
activityName: "",
showAgree: false,//协议
ProtocolDetail: "",
callPriceFlag: "",
tId: null
}
},
watch: {
'checkBoxFlag': function (newValue, oldValue) {
this.checkBoxValue = newValue ? 'success' : 'circle';
},
jspickerDate: function (newValue, oldValue) {
this.jsDate = this.$refs.jspickerDate && this.$refs.jspickerDate.getNameValues();
},
jspickerPerson: function (newValue, oldValue) {
this.jsPerson = this.jspickerPerson.join('');
},
upvalue: function (newValue, oldValue) {

if (this.downvalue && newValue.cityNo != this.downvalue.cityNo) {
this.downvalue = "";

var jbStorage = JSON.parse(window.localStorage.getItem("jbStorage"));
if (jbStorage) {
jbStorage.mapAddress = "";
window.localStorage.setItem("jbStorage", JSON.stringify(jbStorage));
}

return;
}
;

this.bindDateAndPerson(newValue.cityNo);

},
downvalue: function (newValue, oldValue) {
if (this.upvalue && newValue.cityNo != this.upvalue.cityNo) {
this.upvalue = "";

var jbStorage = JSON.parse(window.localStorage.getItem("jbStorage"));
if (jbStorage) {
jbStorage.upvalue = "";
window.localStorage.setItem("jbStorage", JSON.stringify(jbStorage));
}
return;
}
;
},
jsDate: function (newValue, oldValue) {
setTimeout(() => {
this.callPrice();
}, 300);
},
jsPassanger: function (newValue, oldValue) {
setTimeout(() => {
this.callPrice();
}, 300);
},
},
methods: {
yz(val) {
return this.$until.yzFontColor(val);
},

getupvalue() {
this.$store.state.path = "pickupStation";
var cityNo = this.upvalue ? this.upvalue.cityNo : "";
var cityName = this.upvalue ? this.upvalue.cityName : "";
sessionStorage.setItem('jb_shuttleType','0');
this.$router.push("/address?cityNo=" + cityNo + "&cityName=" + cityName);
},
queryProtocolDetail() {
this.$http.post(window.innerAPI + "?server=queryProtocolDetail", {
code: 'p_shuttle'
}).then(res => {
this.ProtocolDetail = res.data.data.content
}).catch(err => {
});
},
changePassanger() {


},

currentPosition() {
var jbStorage = window.localStorage.getItem("jbStorage");
if (jbStorage) {
jbStorage = JSON.parse(jbStorage);
if (jbStorage.upvalue) {
this.upvalue = jbStorage.upvalue;
this.$store.state.mutations.cityNo = this.upvalue.cityNo;
return;
}
}
var map = new BMap.Map("allmap"), that = this, promise = this.promise;
var point = new BMap.Point(116.331398, 39.897445);
map.centerAndZoom(point, 12);
this.$store.state.mutations.map = map;
var geolocation = new BMap.Geolocation(), _this = this;

promise = new Promise(function (resolve, reject) {

geolocation.getCurrentPosition(function (r) {


if (this.getStatus() == BMAP_STATUS_SUCCESS) {

var upPoint = {
point: r.point.lng + "," + r.point.lat,
}
resolve(upPoint);
} else {
reject(r);
}
}, {enableHighAccuracy: true, timeout: 5000})
});
promise.then(function (curPosition) {

if (!curPosition) return;


var jbStorage = window.localStorage.getItem("jbStorage");

let jsShuttleInfo = JSON.parse(sessionStorage.getItem('jb_shuttleInfo')),
_point = jsShuttleInfo ? jsShuttleInfo.point : curPosition.point;
that.$http.post(window.innerAPI + "?server=initStation", {
"ip": "171.88.164.17",
"point": _point,
"channelCode": localStorage.getItem('useCar_jb_channelCode')
})
.then(res => {

if (res.data.data.code == "S001") {
that.$store.dispatch('hideLoading');
localStorage.setItem("$currentCity", "");
return;
}
if (res.data.data) {

that.initStation = res.data.data;
that.upvalue = res.data.data;
that.$currentCity = that.upvalue.cityNo;
localStorage.setItem("$currentCity", that.upvalue.cityNo);
that.$store.state.mutations.cityNo = that.upvalue.cityNo;
that.$store.dispatch('hideLoading');

if (jbStorage) {
jbStorage = JSON.parse(window.localStorage.getItem("jbStorage"));
jbStorage.currentPoint = curPosition.point;
jbStorage.upvalue = res.data.data;
jbStorage.cityName = res.data.data.cityName;
window.localStorage.setItem("jbStorage", JSON.stringify(jbStorage));
} else {
that.$store.state.currentPoint = curPosition.point;
window.localStorage.setItem("jbStorage", JSON.stringify({
"currentPoint": curPosition.point,
"upvalue": that.upvalue,
"cityName": that.upvalue.cityName
}));
}
} else {
that.upvalue = "";
localStorage.setItem("$currentCity", "");
that.$store.dispatch('hideLoading');
}
}).catch(function (errr) {


that.$store.dispatch('hideLoading');
that.upvalue = "";
localStorage.setItem("$currentCity", "");
})
})
.catch(function (msg) {

that.$store.dispatch('hideLoading'); 
that.$vux.toast.show({
text: "不在服务区",
type: "text"
});
that.upvalue = "";
localStorage.setItem("$currentCity", "");
})
},

getdownvalue() {

var labelflag = 1;
if (!this.upvalue) {
this.$vux.toast.show({
text: "请先设置起点",
type: "text"
});
return;
}


if (localStorage.getItem("$currentCity") != this.upvalue.cityNo) {
labelflag = 0; 
}
this.$router.push("/arriveAddressB?title=1&label=" + labelflag);
},

checkPassanger() {
var passanger = window.localStorage.getItem("userMessage");
if (!passanger) return;
this.jsPassanger = JSON.parse(passanger);
this.loginFlag = true;
},

yzDatePerson(label) {
if (!this.upvalue) {
this.$vux.toast.show({
text: "请选择上车地点",
type: "text"
})
return;
} else if (!this.downvalue) {
this.$vux.toast.show({
text: "请选择下车地点",
type: "text"
})
return;
}
label ? this.showPopupPicker = true : this.showPickerPerson = true
},

bindDateAndPerson(cityNo) {
var that = this;
this.$until.getDateTime(this, cityNo).then(function (data) {
that.list3 = data.jspickerDate;
that.personList = [data.personList];
})
},

callPrice(val) {


if (!this.upvalue || !this.downvalue || !this.jsDate || !this.jsPassanger) {

return;
}

this.$http.post(window.innerAPI + "?server=queryShuttlePrice", {
"bizTypeStr": "2",
"downPoint": this.downvalue.point.lat + "," + this.downvalue.point.lng,
"startSiteNo": this.upvalue.siteNo,
"numbers": this.jsPerson,
"useDate": this.$until.updateDate(this.jsDate),
"userToken": window.localStorage.getItem("cdqcp_opid") || window.localStorage.getItem("useCar_cdqcp_opid"),
}).then(res => {
if (res.data.data.code) {
this.callPriceFlag = res.data.data.errmsg;
this.$vux.toast.show({
text: res.data.data.errmsg,
type: "text"
});
return;
}
this.callPriceFlag = "";
this.payPrice = res.data.data.data.notCarpoolPayPrice;
this.activityName = res.data.data.data.details[0].activityName;
}).catch(err => {

});
},

comfirmOrder() {
var that = this;
if (!this.upvalue || !this.downvalue || !this.jsDate || !this.jsPerson || !this.jsPassanger) {

this.$vux.toast.show({
text: "请完善订单信息",
type: "text"
});
return;
} else if (!this.checkBoxFlag) {
this.$vux.toast.show({
text: "请同意服务协议",
type: "text"
})
return;
} else if (this.upvalue.cityNo != this.downvalue.cityNo) {
this.$vux.toast.show({
text: "起止点不在同一城市，请重新设置",
type: "text"
})
return;
} else if (this.callPriceFlag) {
this.$vux.toast.show({
text: this.callPriceFlag,
type: "text"
});
return;
}
var arr = [];
for (var i = 0; i < this.jsPerson; i++) {
arr.push({});
}

var _p_from = this.$until.judgeBrowser();
window.clearTimeout(this.tId);

this.tId = setTimeout(() => {

this.$http.post(window.innerAPI + "?server=initOrder", {
"bizType": "2",
"shiftNo": "1111",
"downPoint": this.downvalue.point.lat + "," + this.downvalue.point.lng,
"lineSiteSartNo": this.upvalue.siteNo,
"numbers": this.jsPerson[0],
"bookDate": this.$until.updateDate(this.jsDate).split(" ")[0],
"driverTime": this.$until.updateDate(this.jsDate).split(" ")[1],
"contactMobile": this.jsPassanger.split(' ')[1],
"contactName": this.jsPassanger.split(' ')[0],
"upAddress": this.upvalue.siteName,
"downAddress": this.downvalue.address,
"userToken": window.localStorage.getItem("cdqcp_opid") || window.localStorage.getItem("useCar_cdqcp_opid"),
"passengersStr": JSON.stringify(arr),
"_p_from": _p_from
}).then(res => {

if (res.data.data.code == "30000") {
this.$vux.toast.show({
text: res.data.data.errmsg,
type: "text"
});
return;
}
if (res.data.msg) {
this.$vux.toast.show({
text: res.data.msg,
type: "text"
});
return;
}

if (res.data.data.code) {
this.$vux.toast.show({
text: res.data.data.msg,
type: "text"
})
return;
}
if (res.data.data) {
this.$until.getBackUrl(this, res.data.data.orderNo);

}
}).catch(err => {

});
}, DEBOUNCE_TIME)

},

init() {
var initMsg = localStorage.getItem("jbStorage");
if (initMsg) {
initMsg = JSON.parse(initMsg);
this.downvalue = initMsg.mapAddress ? initMsg.mapAddress : "";
} else {
this.downvalue = "";
}


this.currentPosition();

this.checkPassanger();
},

},
activated() {
this.payPrice = "";
this.$store.state.mutations.path = "pickupStation";
this.$store.state.mutations.cityAddress = false;


this.init();
},
beforeCreate() {
let me = this;
if(this.$until.getUrlParam('stationName')){
let shuttleInfo = {
cityName:'',
jsPassageValue:'',
jsPassager:'',
currentPoint: this.$until.getUrlParam('stationLng') + "," + this.$until.getUrlParam('stationLat'),
upvalue: {
cityName:'',
cityNo:me.$until.getUrlParam('targetNo'),
enCityName:'',
enName:'',
siteName:me.$until.getUrlParam('stationName'),
siteNo:me.$until.getUrlParam('stationNo')
}
};
localStorage.setItem('jbStorage', JSON.stringify(shuttleInfo));
}

},
mounted() {
this.payPrice = "";

this.queryProtocolDetail()
}
}



// WEBPACK FOOTER //
// ./src/components/pickGiveStation/pickupStation.vue